import FloatingBarLayout from './FloatingBarLayout';

export default FloatingBarLayout;



// WEBPACK FOOTER //
// ./src/ondemand/components/FloatingBarLayout/index.js